<template>
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.91333 8.71333L6.22 7.04L6.24 7.02C7.4 5.72667 8.22667 4.24 8.71333 2.66667H10.6667V1.33333H6V0H4.66667V1.33333H0V2.66H7.44667C7 3.94667 6.29333 5.16667 5.33333 6.23333C4.71333 5.54667 4.2 4.79333 3.79333 4H2.46C2.94667 5.08667 3.61333 6.11333 4.44667 7.04L1.05333 10.3867L2 11.3333L5.33333 8L7.40667 10.0733L7.91333 8.71333ZM11.6667 5.33333H10.3333L7.33333 13.3333H8.66667L9.41333 11.3333H12.58L13.3333 13.3333H14.6667L11.6667 5.33333ZM9.92 10L11 7.11333L12.08 10H9.92Z"
      fill="#90A4AE"
    />
  </svg>
</template>
